import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row g-3" }
const _hoisted_2 = { class: "row col-md-7" }
const _hoisted_3 = { class: "el-input-group" }
const _hoisted_4 = { class: "col-md-9" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = { class: "row col-md-7" }
const _hoisted_7 = { class: "el-input-group" }
const _hoisted_8 = { class: "col-md-9" }
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = { class: "row col-md-7" }
const _hoisted_11 = { class: "el-input-group" }
const _hoisted_12 = { class: "col-md-9" }
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = { class: "row col-md-7" }
const _hoisted_15 = { class: "el-input-group" }
const _hoisted_16 = { class: "col-md-9" }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = { class: "col-md-7" }
const _hoisted_19 = { class: "el-input-group" }
const _hoisted_20 = {
  key: 2,
  class: "btn btn-loading",
  disabled: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_b_th = _resolveComponent("b-th")!
  const _component_b_tr = _resolveComponent("b-tr")!
  const _component_b_thead = _resolveComponent("b-thead")!
  const _component_b_td = _resolveComponent("b-td")!
  const _component_b_tbody = _resolveComponent("b-tbody")!
  const _component_b_table_simple = _resolveComponent("b-table-simple")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[22] || (_cache[22] = _createElementVNode("h2", null, "Статусы по ДО", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[7] || (_cache[7] = _createElementVNode("label", {
            for: "accountingMonth",
            class: "form-label col-md-3"
          }, "Расчетный месяц", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                min: "1",
                max: "12",
                step: "1",
                class: "form-control",
                id: "accountingMonth",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchParam.accountingMonth) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchParam.accountingMonth]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[8] || (_cache[8] = _createElementVNode("label", {
            for: "accountingYear",
            class: "form-label col-md-3"
          }, "Расчетный год", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                min: "2024",
                step: "1",
                class: "form-control",
                id: "accountingYear",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchParam.accountingYear) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchParam.accountingYear]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[9] || (_cache[9] = _createElementVNode("label", {
            for: "katoCode",
            class: "form-label col-md-3"
          }, "Населенный пункт", -1)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_multiselect, {
                modelValue: _ctx.kato,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.kato) = $event)),
                options: _ctx.katoList,
                searchable: true,
                closeOnSelect: true,
                "track-by": "code",
                "custom-label": _ctx.formattedKatoLabel,
                placeholder: "Выберите Като",
                multiple: false,
                "clear-on-select": true
              }, null, 8, ["modelValue", "options", "custom-label"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[11] || (_cache[11] = _createElementVNode("label", {
            for: "status",
            class: "form-label col-md-3"
          }, "Статус финансирования", -1)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                id: "status",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchParam.lmsStatus) = $event))
              }, _cache[10] || (_cache[10] = [
                _createElementVNode("option", { value: "" }, "Все", -1),
                _createElementVNode("option", { value: "ACTIVE" }, "Финансируется", -1),
                _createElementVNode("option", { value: "INACTIVE" }, "Не финансируется", -1)
              ]), 512), [
                [_vModelSelect, _ctx.searchParam.lmsStatus]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fetchKindergartenAnalytics()))
              }, "Поиск"))
            : _createCommentVNode("", true),
          (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-info",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.downloadGeneratedCalculationReportList()))
              }, "Выгрузить результат по фильтру"))
            : (_openBlock(), _createElementBlock("button", _hoisted_20, "Загрузка"))
        ])
      ])
    ]),
    _cache[23] || (_cache[23] = _createElementVNode("p", null, null, -1)),
    _createVNode(_component_b_pagination, {
      modelValue: _ctx.currentPage,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentPage) = $event)),
      "total-rows": _ctx.pageResponse?.totalElements,
      "per-page": _ctx.searchParam.perPage
    }, null, 8, ["modelValue", "total-rows", "per-page"]),
    _createVNode(_component_b_table_simple, { bordered: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_thead, { "head-variant": "light" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_tr, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_th, { style: {"width":"3%"} }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode("#")
                  ])),
                  _: 1
                }),
                _createVNode(_component_b_th, { style: {"width":"20%"} }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode("Название ДО")
                  ])),
                  _: 1
                }),
                _createVNode(_component_b_th, { style: {"width":"10%"} }, {
                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                    _createTextVNode("БИН")
                  ])),
                  _: 1
                }),
                _createVNode(_component_b_th, { style: {"width":"10%"} }, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                    _createTextVNode("LMS ID")
                  ])),
                  _: 1
                }),
                _createVNode(_component_b_th, { style: {"width":"17%"} }, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                    _createTextVNode("Населённый пункт")
                  ])),
                  _: 1
                }),
                _createVNode(_component_b_th, { style: {"width":"7%"} }, {
                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                    _createTextVNode("Табель \"План\" за текущий месяц")
                  ])),
                  _: 1
                }),
                _createVNode(_component_b_th, { style: {"width":"7%"} }, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createTextVNode("Табель \"Факт\" за предыдущий месяц")
                  ])),
                  _: 1
                }),
                _createVNode(_component_b_th, { style: {"width":"7%"} }, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createTextVNode("PDF сформирован")
                  ])),
                  _: 1
                }),
                _createVNode(_component_b_th, { style: {"width":"7%"} }, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createTextVNode("Подписан")
                  ])),
                  _: 1
                }),
                _createVNode(_component_b_th, { style: {"width":"12%"} }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createTextVNode("Финансирование")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_tbody, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kindergartenAnalytics || [], (document, docIndex) => {
              return (_openBlock(), _createBlock(_component_b_tr, { key: docIndex }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_td, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(docIndex+1), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_b_td, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(document.kindergartenName), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_b_td, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(document.bin), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_b_td, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(document.lmsId), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_b_td, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(document.katoNameRu), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_b_td, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getYesNoRu(document.hasPlanTimesheet)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_b_td, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getYesNoRu(document.hasFactTimesheet)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_b_td, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getYesNoRu(document.hasPDFForSign)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_b_td, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getYesNoRu(document.isSigned)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_b_td, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getStatusLabel(document.status)), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}